export const Draggable = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="10.5" y="6.5" width="3" height="3" rx="1.5" fill="currentColor" stroke="currentColor"/>
<rect x="10.5" y="14.5" width="3" height="3" rx="1.5" fill="currentColor" stroke="currentColor"/>
<rect x="10.5" y="22.5" width="3" height="3" rx="1.5" fill="currentColor" stroke="currentColor"/>
<rect x="18.5" y="14.5" width="3" height="3" rx="1.5" fill="currentColor" stroke="currentColor"/>
<rect x="18.5" y="6.5" width="3" height="3" rx="1.5" fill="currentColor" stroke="currentColor"/>
<rect x="18.5" y="22.5" width="3" height="3" rx="1.5" fill="currentColor" stroke="currentColor"/>
</svg>`;
